import React from 'react';
import PropTypes from 'prop-types';

export default function Checkbox(props) {
  let { label, className, id, ...args } = props;
  return (
    <label className={`km__c--checkbox ${className ? className : ''}`} id={id}>
      {label}
      <input type='checkbox' {...args} />
      <span className='km__c--checkbox-checkmark'/>
    </label>
  );
}
Checkbox.propTypes = {
  label: PropTypes.string,
};
